export interface LandingTranslations {
  navbar: {
    home: string;
    profile: string;
    facilities: string;
    opportunities: string;
    potentialMap: string;
    contact: string;
    language: string;
  };
  hero: {
    title: string;
    subtitle: string;
    slide1: {
      title: string;
      subtitle: string;
    };
    slide2: {
      title: string;
      subtitle: string;
    };
    slide3: {
      title: string;
      subtitle: string;
    };
  };
  profile: {
    title: string;
    description: string;
    whyInvest: string;
    advantages: string[];
  };
  facilities: {
    title: string;
    description: string;
    items: {
      tollRoad: { title: string; description: string; };
      airport: { title: string; description: string; };
      railway: { title: string; description: string; };
      industrial: { title: string; description: string; };
      education: { title: string; description: string; };
      healthcare: { title: string; description: string; };
      energy: { title: string; description: string; };
      telecommunications: { title: string; description: string; };
      humanResources: { title: string; description: string; };
    };
  };
  opportunities: {
    title: string;
    description: string;
    sectors: {
      guitar: { title: string; description: string; };
      textile: { title: string; description: string; };
      agro: { title: string; description: string; };
      furniture: { title: string; description: string; };
      automotive: { title: string; description: string; };
      tourism: { title: string; description: string; };
    };
  };
  investmentOpportunities: {
    title: string;
    description: string;
  };
  cta: {
    title: string;
    description: string;
    viewMap: string;
    contactUs: string;
  };
  footer: {
    description: string;
    quickNav: string;
    contactInfo: string;
    office: string;
    fullOffice: string;
    address: string;
    addressFull: string;
    phone: string;
    email: string;
    officeHours: string;
    officeHoursFull: string;
    copyright: string;
  };
}

export const landingTranslations: { [key: string]: LandingTranslations } = {
  id: {
    navbar: {
      home: 'Beranda',
      profile: 'Profil',
      facilities: 'Fasilitas',
      opportunities: 'Peluang',
      potentialMap: 'Peta Potensi',
      contact: 'Kontak',
      language: 'Bahasa'
    },
    hero: {
      title: 'Ruang Investasi Sukoharjo',
      subtitle: 'Gerbang Menuju Investasi yang Makmur dan Berkelanjutan',
      slide1: {
        title: 'Ruang Investasi Sukoharjo',
        subtitle: 'Gerbang Menuju Investasi yang Makmur dan Berkelanjutan'
      },
      slide2: {
        title: 'Lokasi Strategis',
        subtitle: 'Terhubung dengan Kota-kota Besar dan Jaringan Transportasi'
      },
      slide3: {
        title: 'Ekonomi Berkembang',
        subtitle: 'Sektor Industri dan Pertanian yang Berkembang Pesat'
      }
    },
    profile: {
      title: 'Profil Sukoharjo',
      description: 'Kabupaten Sukoharjo berlokasi strategis di Jawa Tengah, Indonesia. Dikenal dengan warisan budayanya yang kaya, basis industri yang kuat, dan konektivitas yang sangat baik ke pusat-pusat ekonomi utama. Wilayah ini menawarkan perpaduan sempurna antara nilai-nilai tradisional dan pembangunan modern, menjadikannya destinasi ideal untuk investasi berkelanjutan.',
      whyInvest: 'Mengapa Berinvestasi di Sukoharjo?',
      advantages: [
        'Lokasi strategis di Jawa Tengah',
        'Dukungan pemerintah yang kuat dan insentif investasi',
        'Konektivitas transportasi yang sangat baik',
        'Tenaga kerja terampil yang melimpah',
        'Biaya operasional yang kompetitif',
        'Lingkungan politik dan ekonomi yang stabil',
        'Permintaan pasar yang terus berkembang',
        'Infrastruktur industri modern'
      ]
    },
    facilities: {
      title: 'Fasilitas Pendukung',
      description: 'Sukoharjo menyediakan infrastruktur dan fasilitas komprehensif untuk mendukung operasional bisnis Anda',
      items: {
        tollRoad: {
          title: 'Akses Jalan Tol',
          description: 'Akses langsung ke jalan tol utama yang menghubungkan Solo dan Yogyakarta'
        },
        airport: {
          title: 'Kedekatan Bandara',
          description: 'Dekat dengan Bandara Internasional Adi Soemarmo'
        },
        railway: {
          title: 'Jaringan Kereta Api',
          description: 'Terhubung dengan sistem transportasi kereta api nasional'
        },
        industrial: {
          title: 'Kawasan Industri',
          description: 'Zona industri yang berkembang baik dengan infrastruktur modern'
        },
        education: {
          title: 'Pendidikan',
          description: 'Akses ke institusi pendidikan berkualitas dan tenaga kerja terampil'
        },
        healthcare: {
          title: 'Kesehatan',
          description: 'Fasilitas kesehatan modern dan layanan medis'
        },
        energy: {
          title: 'Pasokan Energi',
          description: 'Infrastruktur listrik dan energi yang handal'
        },
        telecommunications: {
          title: 'Telekomunikasi',
          description: 'Internet berkecepatan tinggi dan jaringan komunikasi modern'
        },
        humanResources: {
          title: 'Sumber Daya Manusia',
          description: 'Tenaga kerja terampil dan berdedikasi siap untuk kebutuhan industri'
        }
      }
    },
    opportunities: {
      title: 'Potensi Investasi',
      description: 'Temukan beragam potensi investasi di berbagai sektor unggulan di Sukoharjo',
      sectors: {
        guitar: {
          title: 'Industri Gitar di Baki',
          description: 'Pusat manufaktur gitar terkenal dunia dengan potensi ekspor'
        },
        textile: {
          title: 'Industri Tekstil',
          description: 'Sektor manufaktur tekstil dan garmen yang berkembang'
        },
        agro: {
          title: 'Agroindustri',
          description: 'Pengolahan makanan dan pengembangan produk pertanian'
        },
        furniture: {
          title: 'Industri Mebel',
          description: 'Produksi mebel kayu berkualitas untuk pasar domestik dan ekspor'
        },
        automotive: {
          title: 'Komponen Otomotif',
          description: 'Mendukung industri otomotif dengan manufaktur komponen berkualitas'
        },
        tourism: {
          title: 'Pengembangan Wisata',
          description: 'Peluang pengembangan wisata budaya dan ekowisata'
        }
      }
    },
    investmentOpportunities: {
      title: 'Peluang Investasi',
      description: 'Jelajahi berbagai peluang investasi menarik yang telah diidentifikasi dan siap untuk dikembangkan di Sukoharjo'
    },
    cta: {
      title: 'Tertarik Berinvestasi di Sukoharjo?',
      description: 'Ambil langkah selanjutnya menuju perjalanan investasi Anda di Sukoharjo. Jelajahi peta potensi investasi kami atau hubungi tim investasi kami.',
      viewMap: 'Lihat Peta Potensi',
      contactUs: 'Hubungi Kami'
    },
    footer: {
      description: 'Ruang Investasi Sukoharjo - Gerbang Anda menuju peluang investasi yang makmur dan berkelanjutan.',
      quickNav: 'Navigasi Cepat',
      contactInfo: 'Informasi Kontak',
      office: 'DPMPTSP Sukoharjo',
      fullOffice: 'Dinas Penanaman Modal dan Pelayanan Terpadu Satu Pintu Kabupaten Sukoharjo',
      address: 'Alamat',
      addressFull: 'Jl. Jend. Sudirman No. 1, Sukoharjo, Jawa Tengah 57512, Indonesia',
      phone: 'Telepon',
      email: 'Email',
      officeHours: 'Jam Kerja',
      officeHoursFull: 'Senin - Jumat: 08:00 - 16:00 WIB\nSabtu: 08:00 - 12:00 WIB\nMinggu: Tutup',
      copyright: '© 2024 DPMPTSP Kabupaten Sukoharjo. Semua hak dilindungi.'
    }
  },
  en: {
    navbar: {
      home: 'Home',
      profile: 'Profile',
      facilities: 'Facilities',
      opportunities: 'Opportunities',
      potentialMap: 'Potential Map',
      contact: 'Contact',
      language: 'Language'
    },
    hero: {
      title: 'Ruang Investasi Sukoharjo',
      subtitle: 'The Gateway to Prosperous and Sustainable Investment',
      slide1: {
        title: 'Ruang Investasi Sukoharjo',
        subtitle: 'The Gateway to Prosperous and Sustainable Investment'
      },
      slide2: {
        title: 'Strategic Location',
        subtitle: 'Connected to Major Cities and Transportation Networks'
      },
      slide3: {
        title: 'Growing Economy',
        subtitle: 'Thriving Industrial and Agricultural Sectors'
      }
    },
    profile: {
      title: 'Sukoharjo Profile',
      description: 'Sukoharjo Regency is strategically located in Central Java, Indonesia. Known for its rich cultural heritage, strong industrial base, and excellent connectivity to major economic centers. The region offers a perfect blend of traditional values and modern development, making it an ideal destination for sustainable investment.',
      whyInvest: 'Why Invest in Sukoharjo?',
      advantages: [
        'Strategic location in Central Java',
        'Strong government support and investment incentives',
        'Excellent transportation connectivity',
        'Abundant skilled workforce',
        'Competitive operational costs',
        'Stable political and economic environment',
        'Growing market demand',
        'Modern industrial infrastructure'
      ]
    },
    facilities: {
      title: 'Supporting Facilities',
      description: 'Sukoharjo provides comprehensive infrastructure and facilities to support your business operations',
      items: {
        tollRoad: {
          title: 'Toll Road Access',
          description: 'Direct access to major toll roads connecting to Solo and Yogyakarta'
        },
        airport: {
          title: 'Airport Proximity',
          description: 'Close to Adi Soemarmo International Airport'
        },
        railway: {
          title: 'Railway Network',
          description: 'Connected to national railway transportation system'
        },
        industrial: {
          title: 'Industrial Areas',
          description: 'Well-developed industrial zones with modern infrastructure'
        },
        education: {
          title: 'Education',
          description: 'Access to quality educational institutions and skilled workforce'
        },
        healthcare: {
          title: 'Healthcare',
          description: 'Modern healthcare facilities and medical services'
        },
        energy: {
          title: 'Energy Supply',
          description: 'Reliable electricity and energy infrastructure'
        },
        telecommunications: {
          title: 'Telecommunications',
          description: 'High-speed internet and modern communication networks'
        },
        humanResources: {
          title: 'Human Resources',
          description: 'Skilled and dedicated workforce ready for industry needs'
        }
      }
    },
    opportunities: {
      title: 'Investment Potentials',
      description: 'Discover diverse investment potentials across various key sectors in Sukoharjo',
      sectors: {
        guitar: {
          title: 'Guitar Industry in Baki',
          description: 'World-renowned guitar manufacturing center with export potential'
        },
        textile: {
          title: 'Textile Industry',
          description: 'Growing textile and garment manufacturing sector'
        },
        agro: {
          title: 'Agroindustry',
          description: 'Food processing and agricultural product development'
        },
        furniture: {
          title: 'Furniture Industry',
          description: 'Quality wood furniture production for domestic and export markets'
        },
        automotive: {
          title: 'Automotive Parts',
          description: 'Supporting automotive industry with quality component manufacturing'
        },
        tourism: {
          title: 'Tourism Development',
          description: 'Cultural and eco-tourism potential development opportunities'
        }
      }
    },
    investmentOpportunities: {
      title: 'Investment Opportunities',
      description: 'Explore various attractive investment opportunities that have been identified and ready for development in Sukoharjo'
    },
    cta: {
      title: 'Interested in Investing in Sukoharjo?',
      description: 'Take the next step towards your investment journey in Sukoharjo. Explore our investment potential map or get in touch with our investment team.',
      viewMap: 'View Potential Map',
      contactUs: 'Contact Us'
    },
    footer: {
      description: 'Ruang Investasi Sukoharjo - Your gateway to prosperous and sustainable investment opportunities.',
      quickNav: 'Quick Navigation',
      contactInfo: 'Contact Information',
      office: 'DPMPTSP Sukoharjo',
      fullOffice: 'Investment and One-Stop Integrated Services Office of Sukoharjo Regency',
      address: 'Address',
      addressFull: 'Jl. Jend. Sudirman No. 1, Sukoharjo, Central Java 57512, Indonesia',
      phone: 'Phone',
      email: 'Email',
      officeHours: 'Office Hours',
      officeHoursFull: 'Monday - Friday: 08:00 - 16:00 WIB\nSaturday: 08:00 - 12:00 WIB\nSunday: Closed',
      copyright: '© 2024 DPMPTSP Kabupaten Sukoharjo. All rights reserved.'
    }
  }
};

export const useLandingTranslations = () => {
  // This hook can be used to get translations for the landing page
  const getTranslation = (language: 'id' | 'en' = 'id') => {
    return landingTranslations[language];
  };
  
  return { getTranslation };
};